import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";

export default function PrivateRoute({ children }: any) {
  const [user, loading] = useAuthState(auth);

  if (loading) return null;

  return user ? children : <Navigate to="/login" />;
}
